import { Map, fromJS } from 'immutable'

export const UPDATE_IMPORT_DATA = 'UPDATE_IMPORT_DATA'
export function updateImportData(collection, importData) {
  return {
    type: UPDATE_IMPORT_DATA,
    collection,
    importData,
  }
}

export const CLEAR_IMPORT_DATA = 'CLEAR_IMPORT_DATA'
export function clearImportData(collection) {
  return {
    type: CLEAR_IMPORT_DATA,
    collection,
  }
}

const structure = {
  importData: '',
}

const initialState = Map({})

export default function importData (state = initialState, action) {

  switch (action.type) {

    case UPDATE_IMPORT_DATA : {
      const { collection, importData } = action
      if (!state.has(collection)) state = state.set(collection, fromJS(structure))
      return state.setIn([collection, 'importData'], importData)
    }

    case CLEAR_IMPORT_DATA : {
      const { collection } = action
      return state.delete(collection)
    }

    default :
      return state
  }
}
